import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';


class Contact extends Component {
    static defaultProps = {
        center: {
          lat: 52.087601,
          lng: 20.822391
        },
        zoom: 16
      };

    componentDidMount(){
        document.body.className = "contact";
	}

    render() {
        return (
            <div className="box">
                 <div className="moje">
                    <h2>Godziny otwarcia:</h2>
                    <p className="kont-p">pon - pt: 8:00 - 21:00</p>
                    <p className="kont-p">sobota: 9:00 - 19:00</p>
                    <p className="kont-p">niedziela: 10:00 - 15:00</p>
                </div>
    
                <div className="moje">
                    <h2>Adres:</h2>
                    <p className="kont-p">ul. Rolna 103, Nadarzyn</p>
                </div>
    
                <div className="moje">
                    <h2>Kontakt:</h2>
                    <p className="kont-p">22 739 88 25</p>
                    <p className="kont-p">602 610 607</p>
                    <p className="kont-p">w sprawie koni: 602 435 839</p>
                    <p id="email">e-mail: vetica@vetica.pl</p>
                </div>
    
                <div id="map">
                <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyAVcBhK6vEzo9aurAuIgZnns7qYiQwy6Xk' }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                    style={{
                        width: "100%",
                        height: "auto"
                      }}
                />
                </div>   

            </div>
        )
    }
}
export default Contact;